/**
 * Translates job requirement values from API (English) to the current language
 * @param requirement - The job requirement string from API
 * @param translations - The translations object from i18n
 * @returns Translated job requirement string
 */
export const translateJobRequirement = (requirement: string, translations: any): string => {
    const jobRequirementMap: { [key: string]: string } = {
        'Static Post': translations?.jobRequirement1 || 'Static Post',
        'Temporary Story': translations?.jobRequirement2 || 'Temporary Story',
        'Short Video': translations?.jobRequirement3 || 'Short Video',
        'Long Video': translations?.jobRequirement4 || 'Long Video',
    };
    return jobRequirementMap[requirement] || requirement;
};

/**
 * Translates an array of job requirements or a single job requirement
 * @param jobRequirement - Array of job requirements or single job requirement string
 * @param translations - The translations object from i18n
 * @returns Translated string (comma-separated if array)
 */
export const translateJobRequirements = (jobRequirement: string | string[], translations: any): string => {
    if (Array.isArray(jobRequirement)) {
        return jobRequirement.map(req => translateJobRequirement(req, translations)).join(', ');
    }
    return translateJobRequirement(jobRequirement, translations);
};

